module.exports = __webpack_public_path__ + "img/PXL_20230524_111238490.0566b38a.jpg";